import { useMutation, useQueryClient } from '@tanstack/react-query';
import { postMarkReportAsRead } from 'Services';
import { RQ_SINGLE_REPORT, RQ_ALL_REPORTS } from 'Utils';

function useMarkReportAsRead(rid: number, reportType: ReportType) {
    const queryClient = useQueryClient();
    return useMutation([RQ_SINGLE_REPORT], () => postMarkReportAsRead(rid), {
        // TODO: error handling TBD
        onSuccess: () => queryClient.invalidateQueries([RQ_ALL_REPORTS, reportType])
    });
}

export default useMarkReportAsRead;
